var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Bold",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.824,1.176a4.108,4.108,0,0,0-5.676,0L1.611,16.713A5.464,5.464,0,0,0,0,20.6v1.9A1.5,1.5,0,0,0,1.5,24H3.4a5.464,5.464,0,0,0,3.889-1.611L22.824,6.852A4.018,4.018,0,0,0,22.824,1.176ZM5.166,20.268A2.519,2.519,0,0,1,3.4,21H3v-.4a2.52,2.52,0,0,1,.732-1.768L15.3,7.267,16.733,8.7ZM20.7,4.731,18.854,6.58,17.42,5.146,19.27,3.3a1.037,1.037,0,0,1,1.433,0A1.015,1.015,0,0,1,20.7,4.731Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0030529b00faf790f2619b4186a58ea9.svg";
export { ForwardRef as ReactComponent };